import { memo } from 'react';
import { Button } from "@/components/ui/button";
import { addMonths, subMonths } from "date-fns";
import { useMonth } from '../MonthContext';

// Imports únicos - elimina duplicação
import { MONTHS } from "../utils/constants";
import { getIcon } from "../utils/icons";

const MonthSelector = () => {
  const { selectedDate, setSelectedDate } = useMonth();

  // Ícones únicos
  const ChevronLeftIcon = getIcon('ChevronLeft');
  const ChevronRightIcon = getIcon('ChevronRight');

  const goToPreviousMonth = () => setSelectedDate(subMonths(selectedDate, 1));
  const goToNextMonth = () => setSelectedDate(addMonths(selectedDate, 1));
  const goToCurrentMonth = () => setSelectedDate(new Date());

  const isCurrentMonth = () => {
    const now = new Date();
    return selectedDate.getMonth() === now.getMonth() && 
           selectedDate.getFullYear() === now.getFullYear();
  };

  const selectedMonth = selectedDate.getMonth();
  const selectedYear = selectedDate.getFullYear();

  return (
    <div className="flex items-center justify-between bg-white rounded-xl shadow-sm p-4">
      <Button
        variant="ghost"
        size="icon"
        onClick={goToPreviousMonth}
        className="text-gray-600 hover:text-emerald-600"
        aria-label="Mês anterior"
      >
        <ChevronLeftIcon className="w-5 h-5" />
      </Button>

      <div className="text-center">
        <h2 className="text-lg font-bold text-gray-900">
          {MONTHS[selectedMonth].label} {selectedYear}
        </h2>
        {!isCurrentMonth() && (
          <Button
            variant="ghost"
            size="sm"
            onClick={goToCurrentMonth}
            className="text-emerald-600 hover:text-emerald-700 text-xs"
          >
            Voltar para hoje
          </Button>
        )}
      </div>

      <Button
        variant="ghost"
        size="icon"
        onClick={goToNextMonth}
        className="text-gray-600 hover:text-emerald-600"
        aria-label="Próximo mês"
      >
        <ChevronRightIcon className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default memo(MonthSelector);
